import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from '@uzurv/core';
import moment, { Moment } from 'moment';

export class DocumentValidators {
  static notExpired(control: AbstractControl): ValidationErrors | null {
    let validationErrors: { [key: string]: boolean } = {};

    const date: Date = control.value;
    const expirationMoment: Moment = moment(date);
    const isExpired = expirationMoment.isBefore(moment());

    if (isNullOrUndefined(date)) {
      validationErrors['required'] = true;
      return validationErrors;
    }

    if (isExpired) {
      validationErrors['documentExpired'] = true;
    } else {
      validationErrors = {};
    }

    return validationErrors;
  }

  static isValidDate(control: AbstractControl): ValidationErrors | null {
    let validationErrors: { [key: string]: boolean } = {};

    if (isNullOrUndefined(control.value)) {
      validationErrors = {};
    } else {
      if (moment(control.value).isValid()) {
        validationErrors = {};
      } else {
        validationErrors['invalidDate'] = true;
      }
    }

    return validationErrors;
  }

  static notAfterToday(control: AbstractControl): ValidationErrors | null {
    let validationErrors: { [key: string]: boolean } = {};
    const date: Date = control.value;
    const dateMoment: Moment = moment(date);
    const isAfterToday = dateMoment.isAfter(moment().endOf('day'));
    if (isNullOrUndefined(date)) {
      validationErrors['required'] = true;
      return validationErrors;
    }
    if (isAfterToday) {
      validationErrors['afterToday'] = true;
    } else {
      validationErrors = {};
    }
    return validationErrors;
  }
}
